import { useState } from "react";
import experienceDetailBG from "../../../assets/images/others/host-side-images/experienceDetailBG.png";
import { ReactComponent as EditBtn } from "../../assets/images/svgs/edit-btn-svg.svg";
import { ReactComponent as LocationIcon } from "../../../assets/images/svgs/locationDark.svg";
import { ReactComponent as CalandarIcon } from "../../../assets/images/svgs/calendarDark.svg";
import { ReactComponent as ClockIcon } from "../../../assets/images/svgs/clockdark.svg";
import ReviewsRatingIcon from "../../../assets/images/svgs/reviewStarSvg.svg";
import CupRatingIcon from "../../../assets/images/svgs/cupIconSvg.svg";
import attende1 from "../../../assets/images/others/host-side-images/attende1.png";
import attende2 from "../../../assets/images/others/host-side-images/attende2.png";
import attende3 from "../../../assets/images/others/host-side-images/attende3.png";
import attende4 from "../../../assets/images/others/host-side-images/attende4.png";
import cupImage1 from "../../../assets/images/others/host-side-images/cupImage1.png";
import cupImage2 from "../../../assets/images/others/host-side-images/cupImage2.png";
import cupImage3 from "../../../assets/images/others/host-side-images/cupImage3.png";
import cupImage4 from "../../../assets/images/others/host-side-images/cupImage4.png";
import cupImage5 from "../../../assets/images/others/host-side-images/cupImage5.png";
import cupImage6 from "../../../assets/images/others/host-side-images/cupImage6.png";
import hostImage from "../../../assets/images/others/host-side-images/hostImg.png";
import eventBadge from "../../../assets/images/others/host-side-images/eventBadge.png";

import { siteRoutes } from "../../../utils/helpers/enums/routes";

import MinorBreadcrumb, {
  MinorBreadcrumbLink,
} from "../../../components/breadcrumbs/MinorBreadcrumb";
import { GENDERS } from "../../../utils/helpers/enums/shared.enum";
import useStore from "../../../hooks/useStore";
import ReviewModal from "./component/ReviewModal";
import { useNavigate } from "react-router-dom";

interface Review {
  id: number;
  name: string;
  date: string;
  review: string;
  rating: number;
  avatar: string;
  ratingIcon: string;
  cupRatingIcon: string;
}

interface Cups {
  id: number;
  cupImage: string;
  price: string;
  title: string;
  times: string;
}

const reviews: Review[] = [
  {
    id: 1,
    name: "Bella Throne",
    date: "Today",
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum, Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum",
    rating: 4.9,
    avatar: attende1,
    ratingIcon: ReviewsRatingIcon,
    cupRatingIcon: CupRatingIcon,
  },
  {
    id: 2,
    name: "Bella Throne",
    date: "Today",
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum, Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum",
    rating: 4.9,
    avatar: attende2,
    ratingIcon: ReviewsRatingIcon,
    cupRatingIcon: CupRatingIcon,
  },
  {
    id: 3,
    name: "Bella Throne",
    date: "Today",
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum, Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum",
    rating: 4.9,
    avatar: attende2,
    ratingIcon: ReviewsRatingIcon,
    cupRatingIcon: CupRatingIcon,
  },
  {
    id: 3,
    name: "Bella Throne",
    date: "Today",
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum, Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum",
    rating: 4.9,
    avatar: attende2,
    ratingIcon: ReviewsRatingIcon,
    cupRatingIcon: CupRatingIcon,
  },
];

const cupsData: Cups[] = [
  {
    id: 1,
    cupImage: cupImage1,
    price: "1$",
    title: "Community Roast",
    times: "2 times",
  },
  {
    id: 2,
    cupImage: cupImage2,
    price: "2$",
    title: "Thanks Latte",
    times: "4 times",
  },
  {
    id: 3,
    cupImage: cupImage3,
    price: "3$",
    title: "Curious Cappucccino",
    times: "4 times",
  },
  {
    id: 4,
    cupImage: cupImage4,
    price: "4$",
    title: "Mentors Mocha",
    times: "2 times",
  },
  {
    id: 5,
    cupImage: cupImage5,
    price: "5$",
    title: "Thank you very Matcha",
    times: "4 times",
  },

  {
    id: 6,
    cupImage: cupImage6,
    price: "6$",
    title: "Grateful Grounds",
    times: "5 times",
  },
];

const MinorRatings: React.FC = () => {
  const navigate= useNavigate();
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const { getUser } = useStore();
  const { user = null } = getUser();
  const breadcrumbLinks: MinorBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.minorHome },
    { title: "Experience ", path: siteRoutes.minorExperiences },
    { title: "Experience Detail", path: siteRoutes.minorExperienceDetail },
    { title: "Rating", path: siteRoutes.minorRatings },
  ];

  return (
    <div>
      <div
        style={{ backgroundImage: `url(${experienceDetailBG})` }}
        className="bg-cover bg-center bg-no-repeat h-full md:h-[500px] w-full"
      >
        <div
          className={`${
            user?.gender === GENDERS.MALE ? "minor-bg-boy" : "minor-bg-girl"
          } h-full `}
        >
          <div className="container">
            <div className="flex flex-wrap justify-between gap-6 items-center py-4">
              <MinorBreadcrumb links={breadcrumbLinks} />
            </div>

            <div className="flex items-end mt-3 sm:mt-14">
              <div className="flex flex-col gap-4">
                <p className="flex items-center text-base text-lightBlackText">
                  <LocationIcon className="mr-1" /> ABC Avenue, San Francisco
                </p>
                <h1 className="text-blackie text-2xl md:3xl lg:text-5xl font-medium ">
                  How to improve your <br /> Communication and Social Life
                </h1>
                <div className="flex flex-wrap gap-4 text-base text-lightBlackText">
                  <p className="flex items-center gap-1">
                    <CalandarIcon /> 14 October, 2024
                  </p>
                  <p className="flex items-center gap-1">
                    <ClockIcon /> 12:30 to 02:30
                  </p>
                </div>
                <div className="flex flex-wrap gap-6 items-center">
                  <div className="flex items-center ">
                    {[attende1, attende2, attende3, attende4].map(
                      (attende, index) => (
                        <img
                          key={index}
                          className={`w-[30px] h-[30px] object-cover object-center rounded-full border border-white ${
                            index > 0 ? "ml-[-8px]" : ""
                          }`}
                          src={attende}
                          alt={`Attendee ${index + 1}`}
                        />
                      )
                    )}
                    <span className="text-base text-lightBlackText ml-2">
                      15+ attending
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-5 items-center">
                    <button className="bg-yellowText rounded-md text-white px-4 py-2">
                      Workshop
                    </button>
                    <span className="text-2xl text-blackie font-semibold">
                      $120
                    </span>
                    <span className="text-xl text-lightBlackText">
                      0 Slots Available
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-6">
        <div className="flex  justify-center mt-4 md:justify-end md:mt-[-120px] lg:mt-[-200px]">
          <div className="flex flex-wrap gap-4 ">
            <div className="flex flex-col items-center justify-center gap-2 rounded-lg bg-white p-4 shadow-md">
              <img
                className="w-[196px] h-[170px]"
                src={eventBadge}
                alt="Event Badge"
              />
              <span className="text-base font-medium">Event Badge</span>
            </div>

            <div   onClick={() => {
                            navigate(siteRoutes.minorProfileDetailHost);
                          }} className="flex flex-col items-center justify-center gap-2 rounded-lg bg-white p-4 shadow-md">
              <img
                className="w-[196px] h-[170px] rounded-full object-contain"
                src={hostImage}
                alt="Host"
              />
              <div className="text-center">
                <p className="font-medium text-lg">Host</p>
                <p className="font-semibold text-base">Steve Johnson</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center gap-4 flex-wrap mt-6">
          <h2 className="text-2xl font-semibold">Reviews</h2>
          <button
            onClick={() => setModalOpen(true)}
            className="px-4 py-2  rounded-full text-white bg-primaryBlueBg cursor-pointer"
          >
            Write a Review
          </button>

          <div className="my-4">
            <div className="border-[0.3px] border-labelTextColor  p-6  rounded-lg shadow-sm flex flex-col gap-10">
              {reviews.map((review) => (
                <div
                  key={review.id}
                  className="flex md:flex-nowrap flex-wrap items-start justify-between "
                >
                  {/* Left Column - User Info and Review */}
                  <div className="flex flex-col gap-3 w-full">
                    {/* User Info */}
                    <div className="flex items-center gap-2">
                      <img
                        src={review.avatar}
                        alt="Avatar"
                        className="w-10 h-10 rounded-full"
                      />
                      <div>
                        <h4 className="font-semibold text-black text-lg">
                          {review.name}
                        </h4>
                        <p className="text-sm text-labelTextColor">
                          {review.date}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="text-blackie">{review.review}</p>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 md:gap-3 md:items-end md:px-6 mt-3">
                    {/* Rating */}
                    <div className="flex items-center space-x-2">
                      {[...Array(5)].map((_, i) => (
                        <img
                          key={i}
                          src={review.ratingIcon}
                          alt="Star Icon"
                          className="w-6 h-6"
                        />
                      ))}
                      <span className="ml-2 text-labelTextColor">
                        ({review.rating})
                      </span>
                    </div>
                    <div>
                      <img
                        src={review.cupRatingIcon}
                        alt="Cup Rating Icon"
                        className="w-14 h-14"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <ReviewModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
      )}
    </div>
  );
};

export default MinorRatings;
